import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SystemSettingsService } from './core/services/system-settings.service';
import { AuthService } from './core/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html'
})
export class AppComponent {

  constructor(private autService: AuthService, private systemSettingsService: SystemSettingsService) {
  }
}
